import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import { config } from '@/utils/config'

/**
 * Güncel dili al - localStorage'dan
 * Not: Dil seçimi language store tarafından yönetilir
 * API istekleri için sadece localStorage'dan okuyoruz
 */
const getCurrentLanguage = () => {
  return localStorage.getItem('app_language') || 'tr'
}

// Company API instance (personel takip işlemleri için)
const api = axios.create({
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Admin API instance (subscription, ödeme, lisans kontrolleri için)
export const adminApi = axios.create({
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// Runtime config'den URL'leri dinamik olarak al
api.interceptors.request.use((requestConfig) => {
  requestConfig.baseURL = config.companyApiUrl
  // Dinamik dil desteği - her istekte güncel dili al
  requestConfig.headers['Accept-Language'] = getCurrentLanguage()
  return requestConfig
})

adminApi.interceptors.request.use((requestConfig) => {
  requestConfig.baseURL = config.adminApiUrl
  // Dinamik dil desteği - her istekte güncel dili al
  requestConfig.headers['Accept-Language'] = getCurrentLanguage()
  return requestConfig
})

// Company API - İstek interceptor
api.interceptors.request.use(
  config => {
    const authStore = useAuthStore()
    const token = authStore.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Admin API - İstek interceptor
adminApi.interceptors.request.use(
  config => {
    const authStore = useAuthStore()
    const token = authStore.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Company API - Yanıt interceptor
api.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      const authStore = useAuthStore()
      authStore.logout()
    }
    return Promise.reject(error)
  }
)

// Admin API - Yanıt interceptor
adminApi.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      const authStore = useAuthStore()
      authStore.logout()
    }
    return Promise.reject(error)
  }
)

export default api 